import { render, staticRenderFns } from "./DSReportDetail.vue?vue&type=template&id=2051d664&"
import script from "./DSReportDetail.vue?vue&type=script&lang=js&"
export * from "./DSReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./DSReportDetail.vue?vue&type=style&index=0&id=2051d664&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports